// src/utils/sendEmail.js
import emailjs from "@emailjs/browser";
import { EMAILJS } from "../config/emailConfig";

/** Format: day/month/year, time (24h), Europe/Lisbon timezone */
const EMAIL_TIMEZONE = "Europe/Lisbon";
const dtf = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
  timeZone: EMAIL_TIMEZONE,
});

function formatDateTimeForEmail(value) {
  if (!value) return "";
  // accept ISO or any Date-parsable string
  const d = value instanceof Date ? value : new Date(value);
  // Intl may insert a non-breaking space; normalize it to a regular space
  return dtf.format(d).replace(/\u00A0/g, " ");
}

/** Email to APPROVER when a new request is created (Account A) */
export function notifyApprover({
  room,
  requester_name,
  requester_email,
  begin_date, // pass ISO or Date
  end_date,   // pass ISO or Date
  motive,
  approval_link,
}) {
  return emailjs.send(
    EMAILJS.approvals.serviceId,
    EMAILJS.approvals.approvalTemplateId,
    {
      to_email: EMAILJS.approvals.approverEmail,
      room,
      requester_name,
      requester_email,
      begin_date: formatDateTimeForEmail(begin_date),
      end_date: formatDateTimeForEmail(end_date),
      motive,
      approval_link,
    },
    EMAILJS.approvals.publicKey
  );
}

/** Email to REQUESTER with approval/rejection decision (Account A) */
export function sendDecisionEmail({
  to_email,
  to_name = "Requester",
  room,
  begin_date, // pass ISO or Date
  end_date,   // pass ISO or Date
  motive = "",
  status,     // "APPROVED" | "REJECTED"
  reason = "",
  reply_to,   // optional
}) {
  return emailjs.send(
    EMAILJS.approvals.serviceId,
    EMAILJS.approvals.decisionTemplateId,
    {
      to_email,
      to_name,
      room,
      begin_date: formatDateTimeForEmail(begin_date),
      end_date: formatDateTimeForEmail(end_date),
      motive,
      status,
      reason,
      reply_to: reply_to || EMAILJS.approvals.approverEmail,
    },
    EMAILJS.approvals.publicKey
  );
}

/** (Optional) Contact email (Account B) */
export function sendContactEmail({ from_name, from_email, message }) {
  return emailjs.send(
    EMAILJS.contact.serviceId,
    EMAILJS.contact.contactTemplateId,
    {
      to_email: EMAILJS.contact.supportEmail,
      from_name,
      from_email,
      message,
    },
    EMAILJS.contact.publicKey
  );
}

export { formatDateTimeForEmail }; // if you want to reuse it elsewhere

